"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Size = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var turnAnimation = react_1.keyframes({
    '0%': {
        strokeDashoffset: 180,
    },
    '50%': {
        strokeDashoffset: 45,
        transform: 'rotate(135deg)',
    },
    '100%': {
        strokeDashoffset: 180,
        transform: 'rotate(450deg)',
    },
});
var rotationAnimation = react_1.keyframes({
    '0%': {
        transform: 'rotate(0deg)',
    },
    '100%': {
        transform: 'rotate(270deg)',
    },
});
var Size;
(function (Size) {
    Size[Size["SMALL"] = 20] = "SMALL";
    Size[Size["REGULAR"] = 48] = "REGULAR";
    Size[Size["LARGE"] = 65] = "LARGE";
})(Size = exports.Size || (exports.Size = {}));
var LoadingSpinner = function (_a) {
    var color = _a.color, _b = _a.size, size = _b === void 0 ? 48 : _b, _c = _a.level, level = _c === void 0 ? 'inline' : _c;
    return (react_1.jsx("svg", { css: __assign(__assign({}, (level === 'page'
            ? {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%);',
            }
            : null)), { animation: rotationAnimation + " 1.35s linear infinite" }), width: size, height: size, viewBox: "0 0 66 66" },
        react_1.jsx("circle", { css: function (theme) { return ({
                strokeDasharray: 180,
                strokeDashoffset: 0,
                transformOrigin: 'center',
                animation: turnAnimation + " 1.35s ease-in-out infinite",
                stroke: color || theme.color.PRIMARY.DEFAULT,
            }); }, fill: "none", strokeWidth: 4, strokeLinecap: "round", cx: "33", cy: "33", r: "30" })));
};
exports.default = Object.assign(LoadingSpinner, { Size: Size });
